import Keycloak from 'keycloak-js';

export const ACCESS_TOKEN_KEY = 'lims_token';
const REFRESH_TOKEN_KEY = 'lims_refresh_token';
const INIT_ERROR_KEY = 'lims_init_error';
const MAX_RETRIES = 3;

export const setTokens = (token: string, refreshToken: string) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

const keycloakConfig: Keycloak.KeycloakConfig = {
  url: process.env.REACT_APP_KEYCLOACK_URL!,
  realm: process.env.REACT_APP_KEYCLOACK_REALM!,
  clientId: process.env.REACT_APP_KEYCLOACK_CLIENT_ID!
};

export const keycloak = new Keycloak(keycloakConfig);

export const isAuthenticated = () => {
  return !!keycloak.token;
};

export const getAccessToken = () => {
  return keycloak.token;
};

export const updateToken = (callback: () => void) => {
  return keycloak.updateToken(60).then(callback).catch(keycloak.login);
};

export const initializeKeycloak = (
  callback: (isAuthenticated: boolean) => void,
  onError?: (error: string) => void
) => {
  // Check if we've had too many errors (prevent infinite loop)
  const errorCount = parseInt(sessionStorage.getItem(INIT_ERROR_KEY) || '0');
  if (errorCount >= MAX_RETRIES) {
    console.error('Too many Keycloak init errors. Stopping to prevent loop.');
    sessionStorage.removeItem(INIT_ERROR_KEY);
    onError?.(
      'Too many authentication failures. Please clear your browser data and try again.'
    );
    return;
  }

  const token = localStorage.getItem(ACCESS_TOKEN_KEY) ?? '';
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY) ?? '';

  keycloak
    .init({
      onLoad: 'login-required',
      flow: 'standard',
      pkceMethod: 'S256',
      useNonce: true,
      token: token,
      refreshToken: refreshToken,
      checkLoginIframe: false
    })
    .then(isAuthenticated => {
      sessionStorage.removeItem(INIT_ERROR_KEY); // Clear error count on success
      callback(isAuthenticated);
    })
    .catch(err => {
      const newErrorCount = errorCount + 1;
      sessionStorage.setItem(INIT_ERROR_KEY, newErrorCount.toString());
      console.error('Keycloak init error:', err);
      onError?.('Authentication failed. Please try again.');
    });
};
